import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { movies, movieTags } from '../data/mock';

const Movies = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTag = searchParams.get('lang') || 'All';

  const filteredMovies = useMemo(() => {
    if (activeTag === 'All') return movies;
    return movies.filter((movie) => movie.tags.includes(activeTag));
  }, [activeTag]);

  const handleTagClick = (tag) => {
    if (tag === 'All') {
      setSearchParams({});
    } else {
      setSearchParams({ lang: tag });
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-serif mb-3">Movies</h1>
      <p className="text-sm text-[#8f8fa3] mb-8">
        A short list of my most liked films from the past few years.
      </p>

      {/* Language filter */}
      <div className="flex flex-wrap gap-3 mb-8 pb-6 border-b border-[#1f1f23]">
        {movieTags.map((tag) => (
          <button
            key={tag}
            onClick={() => handleTagClick(tag)}
            className={`text-sm transition-colors ${
              activeTag === tag
                ? 'text-white font-medium'
                : 'text-[#8f8fa3] hover:text-white'
            }`}
          >
            {tag}
          </button>
        ))}
      </div>

      <div className="space-y-0">
        {filteredMovies.map((movie, index) => (
          <div
            key={movie.id || `${movie.title}-${index}`}
            className="py-4 border-b border-[#1f1f23] flex items-baseline justify-between gap-4"
          >
            <div>
              <span className="font-medium text-white">{movie.title}</span>
              <div className="flex flex-wrap gap-2 mt-2">
                {movie.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs text-[#c5c5d0] bg-[#151518] px-2 py-0.5 rounded"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <span className="text-xs text-[#7a7a86] uppercase tracking-wide">
              {String(index + 1).padStart(2, '0')}
            </span>
          </div>
        ))}
      </div>

      {filteredMovies.length === 0 && (
        <p className="text-[#8f8fa3] text-center py-12">No films found for this language.</p>
      )}
    </div>
  );
};

export default Movies;
